// Written in this round about way for babel-transform-imports
import Route from 'react-router/es/Route';

export default Route;


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/es/Route.js
// module id = 580
// module chunks = 2